import React from 'react';
import { useTranslation } from 'react-i18next';
import { WelcomeText } from './WelcomeText';

interface RedirectMessageProps {
  seconds: number;
  fadeDelay?: number;
}

export const RedirectMessage: React.FC<RedirectMessageProps> = ({ seconds, fadeDelay = 0 }) => {
  const { t } = useTranslation();

  return (
    <WelcomeText size="sm" fadeDelay={fadeDelay}>
      {t('welcome.shopify.success.redirecting', { seconds })}
    </WelcomeText>
  );
};
